let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("1bFGp"), load("kDPsc"), load("d864Y")]).then(() => parcelRequire('8rWqo'));